import { render, staticRenderFns } from "./OperationSubsidyInactiveGuo.vue?vue&type=template&id=024e57c6&scoped=true"
import script from "./OperationSubsidyInactiveGuo.vue?vue&type=script&lang=js"
export * from "./OperationSubsidyInactiveGuo.vue?vue&type=script&lang=js"
import style0 from "./OperationSubsidyInactiveGuo.vue?vue&type=style&index=0&id=024e57c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024e57c6",
  null
  
)

export default component.exports